<template>
	<div class='RealEstateRolodexTables'>
		<div v-if='listOfRolodexes.length === 0'>
			<div class='helperText'>
				Empty
			</div>
		</div>
		<RealEstateRolodexTable v-for='(rolodex, r) in listOfRolodexes'
			v-else
			:key='r'
			:value='rolodex'
			:hideRecomended='hideRecomended'
			:hideMarket='hideMarket'
		/>
	</div>
</template>

<script>
import RealEstateRolodexTable from './components/RealEstateRolodexTable/RealEstateRolodexTable.vue';
export default {
	name:       'RealEstateRolodexTables',
	components: {
		RealEstateRolodexTable
	},
	props: {
		listOfRolodexes: {
			type:    Array,
			default: () => { return []; }
		},
		hideRecomended: {
			type:    Boolean,
			default: false
		},
		hideMarket: {
			type:    Boolean,
			default: false
		},
	}
};
</script>
